import { Component, Injector, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UiEngineComponent } from '../ui-engine/ui-engine.component';
import { DialogConfig } from '../dialog/dialog-config';
import { ModalSize } from '../../services/smart-modal.service';

@Component({
    selector: 'app-pop-uiengine',
    templateUrl: '../ui-engine/ui-engine.component.html',
    standalone: false
})
export class PopUIEngineComponent extends UiEngineComponent {
  filterData: any;
  @Input() action: any;
  data: any;

  constructor(public injector: Injector, public smartModal: BsModalService, public router: Router, public route: ActivatedRoute, public dialogConfig: DialogConfig) {
    super(injector, router, route, smartModal)
  }
  ngOnInit() {
    if (this.route.snapshot.queryParams.hasOwnProperty('filterData')) {
      this.filterData = JSON.parse(this.route.snapshot.queryParams.filterData);
      this.showGridOnly = true;
      this.resourcename = this.filterData.resource;
      super.ngOnInit();
    }
    else if (this.action != undefined) {
      if(this.action.objData != undefined){
        this.loadData(this.action.objData);
      }else{
        this.showGridOnly = true;
        this.showPopUp = true;
        this.resourcename = this.action.resource;
        super.ngOnInit();
      }
    }
    else if (this.dialogConfig && this.dialogConfig.data != undefined) {
      if(this.dialogConfig.data.view_doc_action)
    {
    this.resourcename = this.dialogConfig.data.resource
    this.uiInit();
    }
    else
      this.loadData(this.dialogConfig);
    }

    if (this._currentData['popUiengineConfig'] == undefined)
      this._currentData['popUiengineConfig'] = {};
    this._currentData['popUiengineConfig']['buttonConf'] = true;
  }
  layoutRenderer(resouceDef) {
    // written for emr specific - todo need to remove this
    if (this.route.snapshot.params.hasOwnProperty('action') && this.route.snapshot.params.action == "view") {
      resouceDef.layout.forEach(tab => {
        if (tab.action != "TAB")
          tab['action'] = 'LIST';
        this._currentData.addAllowed == false;
      });
    }
    this._layout_data = {};
    // this.activeTab(resouceDef.layout[0].id);
    this._currentData.tabType = resouceDef.tab_type;
    if (resouceDef.config != undefined && resouceDef.config.list_back_navigation != undefined && !(this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.view_doc_action))
      this._currentData.list_back_navigation = resouceDef.config.list_back_navigation;
    // if (this._currentData.tabType == 'vertical') {
    //   this.communicationService.emitSidebar({ sidebar: false });
    //   this.communicationService.emitChange({ hideMenuIcon: true });
    // }
    this._currentData.tabName = resouceDef.default_layout_id;
    if (resouceDef.default_layout_id != undefined && resouceDef.default_layout_id) {
      this._layout_id = resouceDef.default_layout_id;
    }
    if (resouceDef.banner && resouceDef.banner != undefined) {
      this._currentData.bannerJson = resouceDef.banner;
      this._currentData.showBanner = true;
    }
    if (resouceDef.conditionVisible != undefined) {
      this._currentData.conditionVisibleTab = resouceDef.conditionVisible;
    }
    if (resouceDef.layout != undefined && resouceDef.layout.length) {
      resouceDef.layout = this.rolePermissionService.getAllowedTabs(resouceDef.layout);
      if (resouceDef.default_layout_id == undefined && resouceDef.layout && resouceDef.layout.length > 0)
        this._layout_id = resouceDef.layout[0].id;
      let allPromiseObj: any = [];
      var defaultLayoutFound = false;
      for (const layout of resouceDef.layout) {
        if (resouceDef.default_layout_id != undefined && resouceDef.default_layout_id == layout.id) {
          defaultLayoutFound = true;
        }
        this._layout_data[layout.id] = {};
        this._layout_data[layout.id]['data'] = layout;
        allPromiseObj.push(this.asyncProcess(layout));
      }
      if (resouceDef.default_layout_id != undefined && !defaultLayoutFound && resouceDef.layout.length > 0) {
        this._layout_id = resouceDef.layout[0].id;
      }
      //Checking if all resource json are loaded.
      Promise.all(allPromiseObj).then(() => {
        console.log("Layout Data ", this._layout_data);
        //If no permission redirect to 404
        if (Object.keys(this._layout_data).length > 0)
          this.initLayoutData();
        else
          this.router.navigate(['404'], { skipLocationChange: true });
      });
      // this._currentData.tabConfig = resouceDef.config;
    } else {
      alert("ERROR PLEASE FIX");
    }
  }
 bindDataToGrid(event) {
  if(this.route?.snapshot?.queryParams?.["p__no"] === undefined && this.route?.snapshot?.queryParams?.tab_0 === "billingSummary" && this._currentData?.gridData?.page_no > 0)
  this.route.snapshot.queryParams["p__no"] = this._currentData.gridData.page_no;
  super.bindDataToGrid(event);
  }
  getDataForCurdOperation(resouceDef) {
    this._currentData.resouceDef = resouceDef;
    // localStorage.setItem("CurrentResource", resouceDef.resource);
    this.storageService.setCurrentResource(resouceDef.resource)
    if (this._layout != 'simple') {
      this._currentData.resource = resouceDef.resource;
    }
    if (resouceDef.addButton != undefined && resouceDef.addButton) {
      this._currentData.addButton = resouceDef.addButton;
      this._currentData.addButton.qrCodeScanner = (resouceDef.addButton && resouceDef.addButton.qrCodeScanner ? resouceDef.addButton.qrCodeScanner : true);
    }
    if (resouceDef.query_id != undefined && resouceDef.query_id) {
      this._currentData.query_id = resouceDef.query_id;
    }
    if (this.route.snapshot.queryParams.hasOwnProperty('banner')) {
      this._currentData.bannerJson = JSON.parse(this.route.snapshot.queryParams.banner);
      if (resouceDef.args == undefined)
        this._currentData.showBanner = true;
    } else if (this._currentData.bannerJson != undefined && this._currentData.bannerJson) {
      if (resouceDef.args == undefined)
        this._currentData.showBanner = true;
    } else if (resouceDef.banner != undefined && resouceDef.banner) {
      this._currentData.bannerJson = resouceDef.banner;
      if(this.route && this.route.snapshot && this.route.snapshot.queryParams && this.route.snapshot.queryParams.returnUrl && (this.route.snapshot.queryParams.returnUrl.includes("patientlist_format") || (this.route.snapshot.queryParams.returnUrl.includes("clearance_status") && this.route.snapshot.queryParams.redirectToBilling == "true")))
      {
      let cardData = JSON.parse(sessionStorage.getItem('currentData'));
      this._currentData.bannerJson.datasource={
        "application": "billing",
        "resource": "billing_details",
        "args": "uhId:"+cardData.uhId+",admissionId:"+(cardData.encounter_id?cardData.encounter_id:cardData.admissionId),
        "query_id": "GET_BY_ADMISSION_ID"
      }
    }
    
      if  (this.route.snapshot.queryParams.returnUrl.includes("ip_bed_format")||this.route.snapshot.queryParams.returnUrl.includes("bed_format")||this.route.snapshot.queryParams.returnUrl.includes("dc_bed_format"))
      {
        sessionStorage.removeItem('currentData');
        let bedData = JSON.parse(sessionStorage.getItem('bedManagementData'));
        this._currentData.bannerJson.datasource = {
          "application": "billing",
          "resource": "billing_details",
          "args": "uhId:" + bedData.uhId + ",admissionId:" + (bedData.encounter_id ? bedData.encounter_id : bedData.admissionId),
          "query_id": "GET_BY_ADMISSION_ID"
        }
      }
    
      if (resouceDef.args == undefined)
        this._currentData.showBanner = true;
    } else if (this.bannerJson && this.bannerJson != undefined) {
      this._currentData.bannerJson = this.bannerJson;
    }
    /******************* ACCOUNT AWARE ***************/
    if (this._currentData.bannerJson != undefined && resouceDef.config != undefined && resouceDef.config.account_aware != undefined && this.appService.isFacilityAware()) {
      this._currentData.bannerJson.accountAware = resouceDef.config.account_aware;
    }
    /******************* ACCOUNT AWARE ***************/

    this.getFilter();
    if (resouceDef.form != undefined && resouceDef.form) {

      /*********** loading default form data from path if available */
      if (this._currentData.currentAction === 'ADD' && this.route.snapshot.data.form_data != undefined && this.route.snapshot.data.form_data[this._currentData.currentResource] != undefined) {
        this._currentData.defaultFormData = this.route.snapshot.data.form_data[this._currentData.currentResource];
      } 
      else if((this.route && this.route.snapshot && this.route.snapshot.queryParams && this.route.snapshot.queryParams.returnUrl && this.route.snapshot.queryParams.returnUrl.includes("optical")))
      {
        if(this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.item && this.dialogConfig.data.item.refraction_data)
          this._currentData.defaultFormData = this.dialogConfig.data.item.refraction_data;
      }
      else {
        if (window.history.state != undefined && window.history.state.form_data != undefined) {
          this._currentData.defaultFormData = window.history.state.form_data;
        } else {
          this._currentData.defaultFormData = {};
        }

      }

      /*********** loading default form data from path if available */

      /******** DEOCRATOR IMPLEMENTATION *******/
      if (resouceDef.config != undefined && resouceDef.config.decorator != undefined) {
        //if decorator  not initialzed or its not same as previous decorator then initialze it
        if (!this._currentData.decorator || (this._currentData.decorator && this._currentData.decorator.className != undefined && this._currentData.decorator.className != resouceDef.config.decorator)) {
          this._currentData.decorator = this.baseService.initDecorator(resouceDef.config.decorator, this.route, this.injector);
        }
      }
      /******** DEOCRATOR IMPLEMENTATION *******/

      this.baseService.getReferredField(resouceDef.form, (response) => {
        console.log("Response is ", response);
        this.initConfigForForm(resouceDef);
        if (resouceDef.form.id)
          this._currentData.currentFormFields.id = resouceDef.form.id;
        if (resouceDef.form.datasource)
          this._currentData.currentFormFields.datasource = resouceDef.form.datasource;
        if (resouceDef.form.resetForm)
          this._currentData.currentFormFields.resetForm = resouceDef.form.resetForm;
        if (resouceDef.form.hasOwnProperty('submitButton')) {
          this._currentData.currentFormFields.submitButton = resouceDef.form.submitButton;
        } else {
          this._currentData.currentFormFields.submitButton = true;
        }
        if (resouceDef.form.hasOwnProperty('APIresource')) {
          this._currentData.currentFormFields.APIresource = resouceDef.form.APIresource;
        }
        if (resouceDef.form.hasOwnProperty('append_object')) {
          this._currentData.currentFormFields.append_object = resouceDef.form.append_object;
        }
        this._currentData.currentFormFields.bannerJson = this._currentData.bannerJson;
        this._currentData.currentFormFields.blocks = response;
        this._currentData.currentFormFields.loaded = true;

        this._currentData.customButton = resouceDef.custom_button || {
          "Add": [
            {
              "label": "button.submit",
              "icon": "fa fa-check"
            }
          ],
          "Modify": [
            {
              "label": "button.update",
              "icon": "fa fa-check"
            }
          ]
        };
        if (resouceDef.form.bookmark && this._currentData.bookmarks == undefined) {
          this._currentData.bookmarks = resouceDef.form.bookmark
          this.showBookmarks();
        }
        this.getDataForCrudOperationFn(resouceDef);
      });
    }
    else {
      this.getDataForCrudOperationFn(resouceDef);
    }
  }
  getDataForCrudOperationFn(resouceDef) {
    if (this.dialogConfig && this.dialogConfig.data != undefined && this.dialogConfig.data.addAllowed != undefined) {
      if(resouceDef.config == undefined)
        resouceDef.config = {};
      resouceDef.config.add_required = this.dialogConfig.data.addAllowed;
    }
    super.getDataForCrudOperationFn(resouceDef);
    
  }
  loadData(dialogConfig){
    if(dialogConfig.data.resourceDef != undefined){
      this.parent_id = 0;
      super.initCurrentData();
      this.showGridOnly = true
      this.resourcename = dialogConfig.data.resourceDef.resource;
      this._currentData.resource = this.resourcename;
      this._currentData.json = this._currentData.resource;
      this._currentData.bookmarks = undefined;
      this._currentData.save_key = 'ui_engine_' + this._currentData.json;
      this.preferenceService.getUserPreferenceConfig(this._currentData.save_key, (preferenceData) => {
        this._currentData.preferenceData = preferenceData;
        this._currentData.currentResource = dialogConfig.data.resourceDef.resource;
        this._layout_data = dialogConfig.data.resourceDef;
          super.loadInitalConfig(this._currentData.json, () => {
            super.initLayoutData();
          });
      });
    }else{
      this.showGridOnly = true
      this.showPopUp = true;
      this.resourcename = dialogConfig.data.resource;
      this.bannerJson = dialogConfig.data.bannerJson;
      super.ngOnInit();
    }
  }
  getDataforUiEngine(resouceDef) {
    if (this.dialogConfig.config != undefined) {
      if (resouceDef.config == undefined) {
        resouceDef.config = {};
      }
      resouceDef.config = { ...this.dialogConfig.config, ...resouceDef.config };
    }
    super.getDataforUiEngine(resouceDef);
  }
  initConfigForForm(resource_def) {
    this._currentData.configForm = {
      "submitButton": (this.route && this.route.snapshot && this.route.snapshot.queryParams && this.route.snapshot.queryParams.returnUrl && this.route.snapshot.queryParams.returnUrl.includes("optical")) ?false : true,
      "cancelButton": true,
      "filterForm": false,
      "clearOnSave": resource_def.config && resource_def.config.clearOnSave ? resource_def.config.clearOnSave : false,
      "delegateSave": true,
      "cancelRoute": '',
      "floating_button": resource_def.config && resource_def.config.floating_button ? resource_def.config.floating_button : false,
      'delta_update': resource_def.config && resource_def.config.delta_update ? resource_def.config.delta_update : false,
      "id": this._currentData.resouceDef.resource,
      "isTemplate": resource_def.config && resource_def.config.isTemplate ? resource_def.config.isTemplate : false,
      "isExpendRequired": resource_def.config && resource_def.config.isExpendRequired ? resource_def.config.isExpendRequired : false,
      "barcode": resource_def && resource_def.config && resource_def.config.barcode_config ? resource_def.config.barcode_config : false,
      "relayInfo": resource_def && resource_def.config && resource_def.config.relay_info ? resource_def.config.relay_info : false,
      "QrCodeScan": resource_def && resource_def.config && resource_def.config.QrCodeScan ? resource_def.config.QrCodeScan : false,
      "AbhaAdd": resource_def && resource_def.config && resource_def.config.AbhaAdd ? resource_def.config.AbhaAdd : false,
      "QrCodeSchema": resource_def && resource_def.QrCodeSchema ? resource_def.QrCodeSchema : {}
    }
  }
  confirmBoxResource(data, action) {
    if (this.dialogRef)
      this.dialogRef.close();
    let popupTitle = "";
    this.translateService.translate(action.label).subscribe(x => {
      if (x) {
        popupTitle = x;
      }
    });
    let name: string = "";
    if (action.name != undefined) {
      name = data[action.name];
    } else {
      name = "";
    } setTimeout(() => {
      const dialogRef = this.modalService.confirm(popupTitle, action.message + ' ' + name + '?', ModalSize.Sm);
      dialogRef.subscribe(result => {
        if (result) {
          this.loader.showSpinner();
          if (action.datasource.data != undefined) {
            var res = action.datasource.data[0];
            for(let i = 0; i < Object.keys(res).length; i++) {
              data[Object.keys(res)[i]] = res[Object.keys(res)[i]];
            }
            this.confirmResource(data, action);
          } else {
            this.confirmResource(data, action);
          }
        }
      },
        () => { });
    }, 1000);

  }
  bindGrid(resource?, application?, type?, queryId?, printInfo?, callback = null) {
    this.loader.showSpinner();
    this.updateCurrentDataFromSavedFilter();
    var gridData = JSON.parse(JSON.stringify(this._currentData.gridData));//making a clone
    if(this.route.snapshot['_routerState'].url.includes("advance_approve") || this.route.snapshot['_routerState'].url.includes("billSummaryandCount")){
      let arg = "id:" +this.dialogConfig.data.item.id;
      gridData.args = arg; 
    }
    if(this && this.resourcename == "dispense_order_pouch_detail"){
      let filter = `time:${this.data.time},medicationPrescribe_id:${this.data.medicationPrescribe_id}`;;
      gridData.filter = filter; 
    }
    
    if((this._currentData.resource == 'billing_item_administration' || this._currentData.resource == 'issue_grid' || this._currentData.resource == 'return_grid' || this._currentData.resource == 'all_pharmacy' || this._currentData.resource == 'billing_item_neurology' || this._currentData.resource == 'billing_item_room_rent' || this._currentData.resource == 'billing_item_pathology' || this._currentData.resource == 'billing_item_diet' || this._currentData.resource == 'billing_item_radiology' ||this._currentData.resource == 'billing_item_blood_bank' ||this._currentData.resource == 'billing_item_pulmonology' || this._currentData.resource == 'billing_item_cardiology' || this._currentData.resource == 'billing_item_nuclear_medicine' || this._currentData.resource == 'billing_item_procedure' || this._currentData.resource == 'billing_item_consultation' || this._currentData.resource == 'billing_item_physiotherapy' || this._currentData.resource == 'billing_item_consumable' || this._currentData.resource == 'billing_item_alacart') && this._currentData.bannerJson.existing_data && this._currentData.bannerJson.existing_data.is_addendum){
      this._currentData.APIresource=undefined;
      resource = 'addendum_billing_item'
      this._currentData.query_id = "GET_BY_PATIENT";
      this._currentData.resource = "addendum_billing_item";
      let arg = "addendum_bill_id:"+this._currentData.bannerJson.existing_data.addendum_bill_id;
      gridData.args = gridData.args + ',' + arg;
    }
    if (this._currentData.dataGridConfig.secondary_uhid_default) {
      // gridData['args'] += "," + 'secondary_uhid:true';
      gridData['args']=gridData['args']?gridData['args'] + "," + 'secondary_uhid:true':'secondary_uhid:true';

    }
    if(this.dialogConfig?.data?.args){
      gridData['args']= gridData['args']?gridData['args']+ ","+this.dialogConfig.data.args:this.dialogConfig.data.args;
      //  gridData['args'] += this.dialogConfig.data.args;
    }
    if (this._currentData.dataGridConfig.ehr_view_default || this.ehr_view_default == true)
      gridData['read_scope_level'] = 'account';
    else if (gridData['read_scope_level'] != undefined)
      delete gridData['read_scope_level'];

    if (this._currentData.parameters) {
      gridData['parameters'] = this._currentData.parameters;
    }

    if (queryId == undefined || queryId == '') {
      gridData['query_id'] = this._currentData.query_id == undefined || this._currentData.query_id == "" ? "GET_PAGE" : this._currentData.query_id;
    } else { gridData['query_id'] = queryId == undefined || queryId == "" ? "GET_PAGE" : queryId; }


    if (this._layout_id && this._layout_data[this._layout_id] != undefined) {
      this._layout_data[this._layout_id]['grid_data'] = gridData;
    }
    if (this.route.snapshot.data.foreign_id != undefined && this.route.snapshot.data.foreign_id && this._currentData.currentForeignId) {  // this line is olny work for View_Details three dot click
      if (gridData.hasOwnProperty('filter') && gridData['filter'] != "") {
        gridData['filter'] += "," + this.route.snapshot.data.foreign_id + ':' + this._currentData.currentForeignId;
      } else {
        gridData['filter'] = this.route.snapshot.data.foreign_id + ':' + this._currentData.currentForeignId;
      }
    }

    try {

      if ((this._currentData.gridData && this._currentData.gridData.projectionKeys) || (gridData.printInfo.actionType == "downloadCSV")) {
        gridData['projectionKeys'] = this._currentData.gridData.projectionKeys.toString();

      }
    } catch (error) { }

    if (gridData.order_by && gridData.search && gridData.search != undefined)
      delete gridData.order_by;

    //implementing print
    if (printInfo) {
      if (printInfo.contentType != 'byte_array') {
        printInfo.responseType = "blob";
        var gridTemplate = 'grid';
        if (this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.grid_template != undefined && this._currentData.resouceDef.config.grid_template != "") {
          gridTemplate = this._currentData.resouceDef.config.grid_template;
        }
        if (printInfo.print_data != undefined && printInfo.print_data == "grid" && printInfo.template != undefined) {
          gridTemplate = printInfo.template;
        }
        var args = "reportTemplateId:" + gridTemplate + ",contentType:" + printInfo.file_type;
        if (this.appService.getCurrentLocation() && this.appService.getCurrentLocation().location_id != undefined) {
          args = args + ',location_id:' + this.appService.getCurrentLocation().location_id;
        }
        if (printInfo.actionType != undefined && ["downloadCSV", "download"].indexOf(printInfo.actionType) > -1) {
          args = args + ',downloadCSV:true';
        }
        if (printInfo.download_only != undefined && printInfo.download_only) {
          args = args + ',downloadOnly:true';
        }
        if (this._currentData != undefined && this._currentData.archiveConfig != undefined && this._currentData.archiveConfig.selected != undefined) {
          if (this._currentData.archiveConfig.selected.alias_fields != undefined && this._currentData.archiveConfig.selected.alias_fields) {
            args = args + ',aliasFields:' + btoa(unescape(encodeURIComponent(JSON.stringify(this._currentData.archiveConfig.selected.alias_fields))));
          }
          if (this._currentData.archiveConfig.selected.args != undefined && this._currentData.archiveConfig.selected.args) {
            args = args + ',' + this._currentData.archiveConfig.selected.args;
          }
        }
        if (gridData.args != undefined && gridData.args != "") {
          gridData.args = gridData.args + ',' + args;
        } else {
          gridData.args = args;
        }
      }

      gridData.printInfo = printInfo;
      gridData.page_size = printInfo.page_size;
      // gridData.newPrint = printInfo.newPrint ? printInfo.newPrint : false;
      if (printInfo.amount != undefined) {
        gridData.amount = printInfo.amount;
      }
    } else {
      if (this.isDownloadOnly()) {
        this.loader.hideSpinner();
        return;//no API call is needed since only download of the data is allowed
      }
      /*************** NO COUNT IMPLEMENTATION *******************/
      var defaultNoCount = true;
      if (gridData["query_id"] != undefined && gridData["query_id"] == "GET_PAGE") {
        defaultNoCount = true;
      }
      this._currentData.dataGridConfig.noCount = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.noCount != undefined ? this._currentData.resouceDef.config.noCount : defaultNoCount;
      if (this._currentData.dataGridConfig.noCount != undefined && this._currentData.dataGridConfig.noCount) {
        var args = "noCount:1";
        if (gridData.args != undefined && gridData.args != "" && !gridData.args.includes("noCount")) {
          gridData.args = gridData.args + ',' + args;
        } else if (gridData.args != undefined && gridData.args != "" && gridData.args.includes("noCount")) {
          gridData.args = gridData.args;
        } else {
          gridData.args = args;
        }
      } else if (this._currentData.dataGridConfig.noCount != undefined && !this._currentData.dataGridConfig.noCount && gridData.args != undefined && gridData.args.includes("noCount")) {
        gridData.args = gridData.args.replace("noCount:1", "");
      }

      /*************** NO COUNT IMPLEMENTATION *******************/

      /*************** NO Rule IMPLEMENTATION *******************/
      if ((this.ruleEngineService != undefined && this.ruleEngineService.config != undefined && this.ruleEngineService.config.ruleInfo != undefined && this.ruleEngineService.config.ruleInfo) || (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData['noRule'] != undefined && this._currentData.gridData['noRule'])) {
        if (gridData.args != undefined && gridData.args) {
          gridData.args = gridData.args + ',' + 'noRule:true';
        }
        else {
          gridData.args = 'noRule:true';
        }
        gridData['noRule'] = true;
      }

      try {

        if (this._currentData.saveFilterKey != undefined && this.persistGrid()) {
          delete this._currentData.saveFilterKey;
          this.saveFilterObj({ gridData: gridData }, (responseConfig) => {
            var queryObj = {};
            queryObj[responseConfig["filterSaveKey"]] = responseConfig["filterKey"];

            var url = this.router.createUrlTree([], { relativeTo: this.route, queryParams: queryObj, queryParamsHandling: 'merge' }).toString()
            this.locationCommon.replaceState(url);

            //this.router.onSameUrlNavigation = 'ignore';
            this.router.navigate(['.'], { relativeTo: this.route, queryParams: queryObj, replaceUrl: true, queryParamsHandling: 'merge' });//maintain history so that user could go back (uncommenting because router params was not updating)
          });
        }
        //  else{
        //    this.resetFilterKey();
        //  }
      } catch (e) {
        console.log(e);
        this._currentData.resouceDef.resource
      }

    }

    if (this._currentData["archiveConfig"] != undefined) {
      var argsArchive = "archive_policy:" + this._currentData["archiveConfig"]["selected"]["id"];
      if (this._currentData["archiveConfig"]["selected"]["db_type"] != undefined) {
        argsArchive += ",archive_db_type:" + this._currentData["archiveConfig"]["selected"]["db_type"]
      }
      if (gridData.args != undefined && gridData.args != "") {
        gridData.args = gridData.args + ',' + argsArchive;
      } else {
        gridData.args = argsArchive;
      }
    }



      let splittab = sessionStorage.getItem('splitActiveTab');
    //this will work for normal case
    if (!printInfo && splittab=="split_bill_details") {
      this._currentData.dataGridConfig.customButtonsAllowed=false;
      let from_date_data = sessionStorage.getItem('split_ip_from_date');
      let to_date_data = sessionStorage.getItem('split_ip_to_date');
      let cardData = JSON.parse(sessionStorage.getItem('currentData'));
      var gridData = JSON.parse(JSON.stringify(this._currentData.gridData));//making a clone
      if(this.data.service_type_code == "pharmacy"){
      let split_bill ={
        "args": gridData.args+",startDate:"+from_date_data+",endDate:"+to_date_data,
        "query_id": "GET_BY_PATIENT",
        "page_size": this._currentData.gridData.page_size,
        "search_columns": this._currentData.gridData.search_columns,
        "searchColumns": this._currentData.gridData.searchColumns,
        "search": this._currentData.gridData.search,
        "searchLabel": this._currentData.gridData.searchLabel,

      }
      if(this._currentData && this._currentData.gridData && this._currentData.gridData.page_no!=undefined){
        split_bill["page_no"]= this._currentData.gridData.page_no;
      }
      this.bindGridWithoutPrint(split_bill, "", "billing_item", "billing", callback);
    }
    else{
      let split_bill ={
        "args": "uhId:"+cardData.uhId+",admissionId:"+(cardData.encounter_id?cardData.encounter_id:cardData.admissionId)+",startDate:"+from_date_data+",endDate:"+to_date_data+",serviceType:"+this.data.service_type_code,
        "query_id": "GET_BY_PATIENT",
        "page_size": this._currentData.gridData.page_size
      }
      if(this._currentData && this._currentData.gridData && this._currentData.gridData.page_no!=undefined){
        split_bill["page_no"]= this._currentData.gridData.page_no;
      }
      this.bindGridWithoutPrint(split_bill, "", "billing_item", "billing", callback);
    }
  }
    else if (!printInfo && this.data && this.data.billing_type && this.data.billing_type=="Multiple Secondary") {
      this._currentData.dataGridConfig.customButtonsAllowed=false;
      var gri = JSON.parse(JSON.stringify(this._currentData.gridData));
      let cardData = JSON.parse(sessionStorage.getItem('currentData'));
      if(this.data.service_type_code == "pharmacy"){
        let split_bill ={
          "args": gri.args+",uhId:"+cardData.uhId+",admissionId:"+(cardData.encounter_id?cardData.encounter_id:cardData.admissionId)+",billing_history_details_id:" + this.route.snapshot.queryParams.id,
          "query_id": "GET_BY_PATIENT",
          "page_size": this._currentData.gridData.page_size,
          "search_columns": this._currentData.gridData.search_columns,
          "searchColumns": this._currentData.gridData.searchColumns,
          "search": this._currentData.gridData.search,
          "searchLabel": this._currentData.gridData.searchLabel,
  
        }
        if(this._currentData && this._currentData.gridData && this._currentData.gridData.page_no!=undefined){
          split_bill["page_no"]= this._currentData.gridData.page_no;
        }
        this.bindGridWithoutPrint(split_bill, "", "billing_item", "billing", callback);
      }
      else{
        let split_bill ={
          "args": "uhId:"+cardData.uhId+",admissionId:"+(cardData.encounter_id?cardData.encounter_id:cardData.admissionId)+",billing_history_details_id:" + this.route.snapshot.queryParams.id+",serviceType:"+this.data.service_type_code,
          "query_id": "GET_BY_PATIENT",
          "page_size": this._currentData.gridData.page_size
        }
        if(this._currentData && this._currentData.gridData && this._currentData.gridData.page_no!=undefined){
          split_bill["page_no"]= this._currentData.gridData.page_no;
        }
        this.bindGridWithoutPrint(split_bill, "", "billing_item", "billing", callback);
      }
    }
    else if (!printInfo) {
      this.bindGridWithoutPrint(gridData, "", resource, application, callback);
    }
    //for print
    else if (printInfo) {
      this.bindGridWithPrint(gridData, "", resource, application, printInfo, callback);
    }
    else {
      //do nothing
    }
  }
  bindGridFn() {
    if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
      this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
    } else {
      this.bindGrid((this.action && this.action.resource && this.action.resource !="addendum_cancel_service")?this.action.resource:(this._currentData && this._currentData.resouceDef)?this._currentData.resouceDef.resource :undefined);
    }
  }
  
  bindGridWithoutPrint(gridData, val, resource, application, callback) {
    if(this.router.url.includes("billingsettledDesign") && this._currentData.bannerJson.key && this._currentData.bannerJson.key.is_addendum){
      this._currentData.bulkAction = false;
      resource = "addendum_billing_item";
      var gri = JSON.parse(JSON.stringify(this._currentData.gridData));
      gridData['query_id'] = "GET_ADDENDUM_ITEMS";
      gridData['args'] = gridData['args'] + ",id:"+this._currentData.bannerJson.existing_data.addendum_bill_id+",serviceType_code:"+gri.args.split(",serviceType:")[1];
      super.bindGridWithoutPrint(gridData, val, resource, application, callback);
    }else if((this.dialogConfig && this.dialogConfig['read_scope_level']) || (this.dialogConfig && this.dialogConfig['secondary_uhid_default'])){
      if(this.dialogConfig['read_scope_level'] == "account")
        gridData['read_scope_level'] = 'account';
      if (this.dialogConfig['secondary_uhid_default'] == true)
        gridData['args'] = gridData['args'] + ",secondary_uhid:true"
      else if (!this.dialogConfig['secondary_uhid_default'] && gridData['args'].includes('secondary_uhid')) { gridData['args'].replace(",secondary_uhid:true", ''); }
      super.bindGridWithoutPrint(gridData, val, resource, application, callback);
    }else{
      super.bindGridWithoutPrint(gridData, val, resource, application, callback);
    }
  }
}
